export default __webpack_public_path__ + "static/media/vol6_2.e7555e4e.png";